import React, { useState, useEffect } from 'react';
import { Card, Timeline, Tag, Typography, Spin } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { api } from '../../api/mockData';
import './index.css';

const { Title, Text } = Typography;

const SidebarArchive = () => {
  const [archives, setArchives] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArchives();
  }, []);

  const fetchArchives = async () => {
    try {
      const data = await api.getArchives();
      setArchives(data);
    } catch (error) {
      console.error('获取归档数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const monthNames = ['一月', '二月', '三月', '四月', '五月', '六月', 
                     '七月', '八月', '九月', '十月', '十一月', '十二月'];

  return (
    <Card className="sidebar-archive">
      <Title level={5} className="sidebar-title">
        <CalendarOutlined /> 文章归档
      </Title>
      
      {loading ? (
        <div className="spin-container">
          <Spin size="small" />
        </div>
      ) : (
        <>
          <Timeline className="archive-timeline">
            {archives.slice(0, 5).map((archive, index) => (
              <Timeline.Item 
                key={`${archive.year}-${archive.month}`}
                color={index % 2 === 0 ? 'blue' : 'green'}
              >
                <Link to={`/archive?year=${archive.year}&month=${archive.month}`}>
                  <div className="timeline-item-content">
                    <Text>
                      {archive.year}年 {monthNames[archive.month - 1]}
                    </Text>
                    <Tag color="blue" className="archive-count">
                      {archive.count}篇
                    </Tag>
                  </div>
                </Link>
              </Timeline.Item>
            ))}
          </Timeline>
          
          {archives.length > 5 && (
            <div className="view-all">
              <Link to="/archive">查看全部归档 →</Link>
            </div>
          )}
        </>
      )}
    </Card>
  );
};

export default SidebarArchive;